(function() {
    'use strict';

    define('cvdbPageFilter',['jquery'], function($) {
        var shownCenterIds = [],
            shownTags = [];

        return {
            init: initialize
        }

        function initialize() {
            $('a', '#centerFilters').on('click', function(evt) {
                var target = $(this),
                    centerId = target.data('centerid');
                toggleArrayElement(shownCenterIds, centerId);
                showCandidates();
            });
            $('a', '#tagFilters').on('click', function(evt) {
                var target = $(this),
                    tagid = target.data('tagid');
                toggleArrayElement(shownTags, tagid)
                showCandidates();
            });
        }

        function toggleArrayElement(array, element) {
            if (array.indexOf(element) === -1) {
                array.push(element);
                return;
            }
            array.splice(array.indexOf(element), 1);
        }

        function showCandidates() {
            if (shownCenterIds.length === 0 && shownTags.length === 0)
                showAllCandidates();
            else
                searchCandidates();
        }

        function showAllCandidates() {
            $('#noResults').hide();
            //$('#searchStart').show();
            $('#searchResults').show();
            $('#candidateList > li').show();
        }

        function searchCandidates() {
            //$('#searchStart').hide();
            var hasResult = false;
            $('#candidateList > li')
                .hide()
                .each(function() {
                    var el = $(this),
                        currentCenterId = el.data('centerid'),
                        currentTagIds = el.data('tagids');
                    if (shownCenterIds.length > 0 && shownCenterIds.indexOf(currentCenterId) === -1) {
                        return;
                    }
                    if (shownTags.length > 0 && !oneElementOverlaps(shownTags, currentTagIds)) {
                        return;
                    }
                    hasResult = true;
                    el.show();
                });
            if (hasResult) {
                $('#noResults').hide();
                $('#searchResults').show();
                return;
            }
            $('#searchResults').hide();
            $('#noResults').show();
        }

        function oneElementOverlaps(arr1, arr2) {
            return arr1.some(function(i) {
                return arr2.indexOf(i) > -1;
            })
        }
    })
})();
